import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { IfPermission } from "../../auth/IfPermission";

export function StartButton() {
  const navigate = useNavigate();
  return (
    <IfPermission permission="competitor-link-removals.create">
      <Button variant="contained" onClick={() => {
      void navigate("/competitor-link-removals/create");
    }}>
        Запустить очистку
      </Button>
    </IfPermission>
  );
}
